<template>
  <div class="login-wrap" style="min-width: 1300px">
    <div class="login-left">
      <div class="login-login">
        <img src="~@/assets/img/logo1.png" />
        <span>ELEPHANT</span>
      </div>
      <div class="ms-login">
        <div class="ms-title">Sign in</div>
        <el-form :model="param" :rules="rules" ref="login" class="ms-content">
          <el-form-item prop="username" label="user Name">
            <el-input
              v-model="param.username"
              placeholder="Please enter the account number"
            >
              <!-- <el-button
                slot="prepend"
                icon="icon iconfont icon-gjwx-zhanghao"
              ></el-button> -->
            </el-input>
          </el-form-item>
          <el-form-item prop="password" label="password">
            <el-input
              type="password"
              placeholder="Please input a password"
              v-model="param.password"
              @keyup.enter.native="submitForm()"
            >
              <!-- <el-button
                slot="prepend"
                icon="icon iconfont icon-gjwx-mima"
              ></el-button> -->
            </el-input>
          </el-form-item>
          <!-- <el-form-item prop="verifyCode">
            <el-input
              v-model="param.verifyCode"
              placeholder="请输入验证码"
              @keyup.enter.native="submitForm()"
            >
              <template slot="append" class="login-img">
                <img :src="imgSrc" alt @click="img()" />
              </template>
              <el-button
                slot="prepend"
                icon="icon iconfont icon-gjwx-yanzhengyanzhengma"
              ></el-button>
            </el-input>
          </el-form-item> -->
          <div class="login-btn">
            <el-button type="primary" @click="submitForm()">login</el-button>
          </div>
          <!-- <p class="login-tips">Tips : 用户名和密码随便填。</p> -->
        </el-form>
      </div>
    </div>
    <div class="login-right">
      <div class="login-login">
        <img src="~@/assets/img/logo3.png" />
        <!-- <p>ELEPHANT</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMenusData,
  loginControllerLogin,
  systemAvailabilityState,
  routerPutong,
  routerYonghu,
  routerShenji,
} from '@/api';
export default {
  data: function () {
    return {
      imgSrc: '', //验证码`
      submitFormType: true,
      data: [],
      param: {
        username: '',
        password: '',
        // username: 'admin',
        // password: 'elephant@1802',
      },
      rules: {
        username: [
          {
            required: true,
            message: 'Please enter one user name',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: 'Please input a password',
            trigger: 'blur',
          },
        ],
        verifyCode: [
          {
            required: true,
            message: 'Please enter the verification code',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
    this.img();
    // this.indexAjax();
    // 初始化
    this.setRem();
    // 改变窗口大小时重新设置 rem
    window.onresize = () => {
      this.setRem();
    };
  },
  methods: {
    setRem() {
      console.log(document.documentElement.clientWidth);
      if (document.documentElement.clientWidth < 1366) {
        document.documentElement.style.fontSize = 1366 / 1920 + 'px';
      } else {
        document.documentElement.style.fontSize =
          document.documentElement.clientWidth / 1920 + 'px';
      }
    },
    // 判断是否系统升级
    indexAjax() {
      systemAvailabilityState({}).then((res) => {
        // this.$globalProcessing.reportErrors.error(res.data.msg);
      });
    },
    img() {
      let data = this.$globalProcessing.getDate('year', 0, '-');
      this.imgSrc =
        window.$intercept.intercept2 +
        '/loginController/verifyCode?time=' +
        new Date().getTime();
    },
    clickLogin() {
      loginControllerLogin(this.param).then((res) => {
        if (res.data.code == 200) {
          localStorage.setItem('id', res.data.data.id);
          localStorage.setItem('ms_username', res.data.data.username);
          localStorage.setItem('token', res.data.data.token);
          localStorage.setItem('userRole', res.data.data.userRole);
          this.getMenus(res.data.data.userRole);
        } else {
          this.$globalProcessing.reportErrors.error(res.data.msg);
        }
      });
      // let { data: res } = await loginControllerLogin(this.param);
    },
    submitForm() {
      if (!this.submitFormType) return;
      this.submitFormType = false;
      this.$refs.login.validate((valid) => {
        if (valid) {
          // localStorage.setItem('id', 1);
          // localStorage.setItem('ms_username', 1);
          // localStorage.setItem('token', 'monitoken');
          // localStorage.setItem('userRole', 1);
          this.clickLogin();
          // this.getMenus();
          // return;
          // localStorage.setItem('ms_username', this.param.username);
          // localStorage.setItem('token', 'monitoken');
          // this.getMenus();
        } else {
          return false;
        }
      });
      setTimeout(() => {
        this.submitFormType = true;
      }, 1500);
    },
    // 获取导航数据 userRole为用户权限
    getMenus(userRole) {
      let fun;
      // switch (userRole) {
      //   case '高级用户':
      //     fun = getMenusData;
      //     break;
      //   case '普通用户':
      //     fun = routerPutong;
      //     break;
      //   case '审计管理员':
      //     fun = routerShenji;
      //     break;
      //   case '用户管理员':
      //     fun = routerYonghu;
      //     break;
      //   default:
      // }

      getMenusData().then((res) => {
        this.$message.success(
          'Login succeeded, about to jump to the home page',
        );
        // 处理导航数据
        let resData = this.$globalProcessing.depthCopy(res.data.data);
        this.data = [];
        this.setMenus(resData, this.data, '');
        localStorage.setItem('setMenus', JSON.stringify(this.data));
        setTimeout(() => {
          window.location.href = '/';
        }, 1500);
      });
    },
    // 处理导航格式并存入本地缓存
    setMenus(menusData, data, urlTitle) {
      menusData.forEach((element, index) => {
        let topTitle = '';
        if (urlTitle) {
          topTitle = urlTitle + ' > ' + element.title;
        } else {
          topTitle = element.title;
        }
        data.push({
          icon: element.icon || '',
          index: '/' + element.index,
          title: element.title,
          pagetype: element.pagetype || '',
          urlTitle: topTitle,
        });
        if (element.subs && element.subs.length > 0) {
          data[index].subs = [];
          this.setMenus(element.subs, data[index].subs, data[index].urlTitle);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-input--small .el-input__inner {
  height: 64px !important;
  width: 500rem;
}
/deep/.el-form-item--small .el-form-item__content,
.el-form-item--small .el-form-item__label {
  font-size: 18px;
}
.login-wrap {
  width: 100%;
  height: 100%;
  background: #fafcfe;

  // background-image: url(../../assets/img/login-bg.jpg);
  // background-image: url(~@/assets/img/back.jpg);A
  // background-size: 100% 100%;
  // /deep/ .el-input-group__append {
  //   padding: 0;
  //   height: 26px;
  //   position: relative;
  //   img {
  //     height: 100%;
  //     position: absolute;
  //     left: -87px;
  //     top: 0;
  //   }
  // }
  .login-left {
    width: 50%;
    height: 100%;
    background: #fafcfe;
    box-sizing: border-box;
    border: 1px solid #fafcfe;
    display: inline-block;
    position: relative;
    .login-login {
      width: 300px;
      padding: 40px;
      position: absolute;
      img {
        float: left;
      }
      span {
        float: left;
        text-align: center;
        font-size: 24px;
        margin-top: 5px;
        margin-left: 17px;
        // line-height: 30px
        color: #147dff;
      }
    }
    .ms-login {
      position: absolute;
      left: 20%;
      top: 33%;
      border-radius: 5px;
      text-align: center;
      // border: solid red;

      .ms-title {
        // width: rem;
        line-height: 50px;
        text-align: center;
        font-size: 36rem;
        color: #000;
        // border-bottom: 1px solid #ddd;
      }
    }
  }
  .login-right {
    width: 50%;
    height: 100%;
    background: #fafcfe;
    box-sizing: border-box;
    background-image: url(~@/assets/img/22.png);
    background-size: 100% 100%;
    display: inline-block;
    position: relative;
    .login-login {
      left: 35%;
      top: 33%;
      width: 300px;
      padding: 40px;
      // border: solid red;
      position: absolute;
      text-align: center;
      img {
      }
      p {
        text-align: center;
        font-size: 60px;
        margin-top: 8px;
        margin-left: 17px;
        // line-height: 30px
        color: #fafcfe;
      }
    }
  }

  .ms-content {
    padding: 30px 30px;
  }
  .login-btn {
    text-align: center;
  }
  .login-btn button {
    width: 500rem;
    background: #536afa;
    height: 64px;
    margin-bottom: 10px;
  }
  .login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
  }
  /deep/.iconfont {
    font-size: 16px;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }
  /deep/.el-form-item__error {
    font-size: 12px;
    padding-top: 2px;
  }
}
</style>
